// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconArrowRight.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconArrowRight = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M12.7337 7.32309C13.0888 7.67218 13.0888 8.23816 12.7337 8.58724C12.3787 8.93633 11.803 8.93633 11.448 8.58724L4.26628 1.52596C3.91124 1.17688 3.91124 0.6109 4.26628 0.261814C4.62132 -0.0872714 5.19696 -0.0872714 5.552 0.261814L12.7337 7.32309Z" />
    <path d="M5.55199 15.7382C5.19695 16.0873 4.62132 16.0873 4.26628 15.7382C3.91124 15.3891 3.91124 14.8231 4.26628 14.474L11.448 7.41276C11.803 7.06367 12.3787 7.06367 12.7337 7.41276C13.0888 7.76184 13.0888 8.32782 12.7337 8.67691L5.55199 15.7382Z" />
  </BaseIcon>
);

export default IconArrowRight;
